import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

// Styled components for premium footer
const PremiumFooter = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  color: '#022324',
  position: 'fixed',
  bottom: theme.spacing(2),
  left: '18%',
  right: '2%',
  width: 'auto',
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.5)',
  zIndex: 1000,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
    transform: 'translateY(-2px)'
  },
  [theme.breakpoints.down('sm')]: {
    width: '92%',
    left: '4%',
    right: '4%',
    padding: theme.spacing(2),
  }
}));

const FooterText = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  background: 'linear-gradient(90deg, #022324 0%, #0A4A4D 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  fontSize: '0.95rem',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.85rem',
  }
}));

const AccentDivider = styled('div')(({ theme }) => ({
  height: '2px',
  width: '400px',
  background: 'linear-gradient(90deg, #4AD16E 0%, #08B1B6 100%)',
}));

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <PremiumFooter component="footer">
      <FooterText variant="body2">
        © {currentYear} Svep Kudumbashree District Mission Kasaragod. All rights reserved.
      </FooterText>
      <AccentDivider />
    </PremiumFooter>
  );
};

export default Footer;